module.exports = __webpack_public_path__ + "static/media/mine_banner_150.256c8be3.png";